import { styled } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

const TicketAdvancedLayout = styled(Paper)({
    height: "100%",
    minHeight: 0,
    display: "grid",
    gridTemplateRows: "1fr",
    overflow: "hidden",
    background: "transparent",
    boxShadow: "none",
});

export default TicketAdvancedLayout;
